import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { SEXUAL_ACTIVITY_COLORS } from './SexualActivityChart';

const LEGEND_ITEM = 'mr-3 inline-flex items-center text-subtle-foreground [&_svg]:mr-1';
const LEGEND_DOT = 'mr-1 inline-block size-2 rounded-full';

const SexualActivityChartLegend: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div>
      <span className={LEGEND_ITEM}>
        {/* the icons take the chart's own colour values, so the legend cannot drift away from it */}
        <CaretDownOutlined style={{ color: SEXUAL_ACTIVITY_COLORS.UNPROTECTED }} />
        {t('symptomTracking.survey.sexualActivity.UNPROTECTED')}
      </span>
      <span className={LEGEND_ITEM}>
        <CaretUpOutlined style={{ color: SEXUAL_ACTIVITY_COLORS.PROTECTED }} />
        {t('symptomTracking.survey.sexualActivity.PROTECTED')}
      </span>
      <span className={LEGEND_ITEM}>
        <div className={`${LEGEND_DOT} bg-info`} />
        <div className={`${LEGEND_DOT} border border-inverse`} />
        {t('symptomTracking.cycles.legend.fertile')}
      </span>
    </div>
  );
};
export default SexualActivityChartLegend;
